module.exports = __webpack_public_path__ + "files/e342cfa30ee3090d3eec573620076528.mp3";